import { useEffect, useMemo, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftCallInfoProps } from './props';
import { SarlaftCallInfo } from '../../../../../../shared/types/modules/sarlaft';
import { asyncGetParams } from '../../../../../../services/param.service';
import {
    ChannelBpEnum,
    ISelect,
    ParamEnum,
} from '../../../../../../shared/types/shared';

export const useSarlaftCallInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftCallInfoProps) => {
    const [channels, setChannels] = useState<ISelect[]>([]);
    const [channelParam, setChannelParam] = useState<string>();

    const queryParams = useMemo(
        () => new URLSearchParams(location.search),
        [location.search]
    );
    const callId = queryParams.get('callId')?.trim();
    const channel = queryParams.get('channel')?.trim();

    const onSubmit = (data: SarlaftCallInfo) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        const fetchChannel = async () => {
            if (channel) {
                if (channel === ChannelBpEnum.TELEFONIA) {
                    const param = channels.filter(
                        (item) => item?.name === 'TELEFONÍA'
                    );
                    setChannelParam(
                        param.length > 0 ? (param[0]?.id as string) : undefined
                    );
                } else {
                    const param = channels.filter(
                        (item) => item?.name === channel
                    );
                    setChannelParam(
                        param.length > 0 ? (param[0]?.id as string) : undefined
                    );
                }
            }
        };
        fetchChannel();
    }, [channel, channels]);

    useEffect(() => {
        formik?.setFieldValue('callId', (callId ? callId : data?.callId) || '');
        formik?.setFieldValue(
            'channel',
            (channelParam ? channelParam : data?.channel) || ''
        );
    }, [data, callId, channelParam]);

    useEffect(() => {
        asyncGetParams(ParamEnum.SARLAFT_CHANNEL).then((items) =>
            setChannels(items)
        );
    }, []);

    return {
        formik,
        channels,
    };
};
